/*
 * Copyright © 2017 TEKTELIC Communications Inc.
 */

export default angular.module('tektelic.api.customerSubscription', [])
    .factory('customerSubscriptionService', CustomerSubscriptionService)
    .name;

/*@ngInject*/
function CustomerSubscriptionService($http, $q) {

    var service = {
        deleteCustomerSubscription: deleteCustomerSubscription,
        getCustomerSubscription: getCustomerSubscription,
        getCustomerSubscriptions: getCustomerSubscriptions,
        saveCustomerSubscription: saveCustomerSubscription,
    }

    return service;

    function getCustomerSubscriptions () {
        var deferred = $q.defer();
        $http.get('/api/customerSubscriptions', null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function getCustomerSubscription (customerSubscriptionId) {
        var deferred = $q.defer();
        var url = '/api/customerSubscription/' + customerSubscriptionId;
        $http.get(url, null).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function saveCustomerSubscription (customerSubscription) {
        var deferred = $q.defer();
        var url = '/api/customerSubscription';
        $http.post(url, customerSubscription).then(function success(response) {
            deferred.resolve(response.data);
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

    function deleteCustomerSubscription (customerSubscriptionId) {
        var deferred = $q.defer();
        var url = '/api/customerSubscription/' + customerSubscriptionId;
        $http.delete(url).then(function success() {
            deferred.resolve();
        }, function fail() {
            deferred.reject();
        });
        return deferred.promise;
    }

}



// WEBPACK FOOTER //
// ./src/app/api/customer-subscription.service.js